import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { ErrorResponse } from '@src/interface/api/response.interface'
import { GetCompanyChallengesQueryKey, GetCompanyChallengesResBody } from '@src/type/challenge'
import { getCompanyChallenges } from '@src/lib/api/challenge'

export type ParamType = {
	queryKey: GetCompanyChallengesQueryKey
}

export function useGetCompanyChallengesQuery({ queryKey }: ParamType) {
	const useQueryResult = useQuery<
		GetCompanyChallengesResBody,
		AxiosError<ErrorResponse>,
		GetCompanyChallengesResBody,
		GetCompanyChallengesQueryKey
	>(queryKey, getCompanyChallenges)

	return useQueryResult
}
